export default function sitraToolkit() {
  const nodeList = document.querySelectorAll('.toolkitforms')
  let formTarget

  jQuery(document).on('nfFormSubmitResponse', function() {
    const textLimit = formTarget.getElementsByClassName('char-count-display')
    const submitContainer = formTarget.getElementsByClassName('submit-wrap')
    jQuery(submitContainer[0]).empty()
    jQuery(textLimit[0]).hide()
    setTimeout(() => {
      jQuery(submitContainer[0]).append('<div class="checkmark-circle"></div>')
    }, 300)
  })

  nodeList.forEach((column) => {
    const select = column.getElementsByTagName('select')
    const textAreaContainer = column.getElementsByClassName('sitra-toolkit-form-textarea-container')
    const submitContainer = column.getElementsByClassName('submit-wrap')
    const match = column.className.match(/toolkit-form-(\d)/)
    const promptIndex = match ? parseInt(match[1], 10) : null

    if (promptIndex) {
      setTimeout(() => {
        const submitButton = column.querySelector('input[type="submit"]')

        if (select.length > 0) {
          const options = select[0].querySelectorAll('option')
          if (options.length > 0) {
            const selectedOption = options[promptIndex - 1]
            if (selectedOption) {
              setTimeout(() => {
                // See Ninja Forms documentation: Changing Field Values
                jQuery(select[0]).val(selectedOption.value).trigger('change')
              }, 100)

              if (textAreaContainer.length > 0) {
                const textAreaLabel = textAreaContainer[0].getElementsByTagName('label')[0]
                const textArea = textAreaContainer[0].getElementsByTagName('textarea')[0]
                const charCountDisplay = document.createElement('div')
                submitContainer[0].insertAdjacentElement('beforebegin', charCountDisplay);
                const maxCount = textArea.getAttribute('maxlength');
                charCountDisplay.className = 'char-count-display';
                charCountDisplay.textContent = `0 / ${maxCount}`;


                if (textAreaLabel) {
                  textAreaLabel.innerHTML = `${selectedOption.textContent}`
                }




                if (textArea) {
                  textArea.addEventListener('input', function(event) {
                    const charCount = event.currentTarget.value.length
                    charCountDisplay.textContent = `${charCount} / ${maxCount}`;
                  });
                }


                if (submitButton) {
                  jQuery(submitButton).on('click', function(event) {
                    formTarget = event.target.closest('form')
                  })
                }
              }

            }
          }
        }
      }, 300)
    }
  })
}
